import * as React from "react";
import jwt_decode, { JwtPayload } from "jwt-decode";
import Button from "@components/button";
import { BookVendorService } from "@graphql/mutations/vendor.mutation";
import {
  BookVendorServiceMutation,
  BookVendorServiceMutationVariables,
} from "@graphql/types";
import { CookieValueTypes } from "cookies-next";
import { useRouter } from "next/router";
import DateTimePicker from "react-datetime-picker/dist/entry.nostyle";
import toast from "react-hot-toast";
import { useMutation } from "urql";
import { refreshOnClientError } from "@utils/auth";

type Props = {
  serviceName: string;
  accessToken: CookieValueTypes;
  id: string;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const SetBooking: React.FC<Props> = (props) => {
  const [bookDate, setBookDate] = React.useState(new Date());
  const accessTokenDecoded = !!props.accessToken
    ? jwt_decode<JwtPayload>(props.accessToken as string)
    : null;

  const router = useRouter();

  const [bookVendorResult, bookVendorFn] = useMutation<
    BookVendorServiceMutation,
    BookVendorServiceMutationVariables
  >(BookVendorService);

  const handleBooking = () => {
    if (!!props.accessToken) {
      toast.success(
        <p className="toast">You have booked {props.serviceName}</p>
      );
      props.setOpenModal(false);
      bookVendorFn({
        date: bookDate,
        vendorServiceId: props.id,
      })
        .then((res) => {
          if (
            res.error?.message.includes("unauthenticated") &&
            !!accessTokenDecoded?.exp &&
            Date.now() >= accessTokenDecoded?.exp * 1000
          ) {
            refreshOnClientError();
          } else if (res.error?.message) {
            console.log("here ", res.error.message);
            toast.error(
              <p className="toast">
                Couldn&apos;t book{" "}
                <span className="font-bold">{props.serviceName}</span>
              </p>
            );
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(
            <p className="toast">
              Couldn&apos;t book{" "}
              <span className="font-bold">{props.serviceName}</span>{" "}
            </p>
          );
        });
    } else {
      router.push("/login");
      toast.error(
        <p className="toast">You need to be logged in to book a vendor</p>
      );
    }
  };

  return (
    <>
      <h1 className="text-xl md:text-2xl text-inawo-green line-clamp-1 w-full font-bold">
        Book A Vendor
      </h1>
      <div className="flex flex-col w-full justify-start items-start gap-6 mt-6 md:mt-8">
        <div className="flex flex-col justify-start items-start gap-0 w-full">
          <label
            htmlFor="date"
            className="text-base font-sfpro text-inawo-grey-200"
          >
            Pick a date
          </label>
          <DateTimePicker
            value={bookDate}
            name="date"
            minDate={new Date()}
            onChange={setBookDate}
            className="border-0 border-b text-base py-3 pl-0 border-inawo-grey-300 w-full focus:ring-0 focus:border-inawo-green transition"
          />
        </div>
        <div className="w-full flex justify-end items-center">
          <Button
            handleClick={() => {
              handleBooking();
            }}
            loader={bookVendorResult.fetching}
            disabled={bookVendorResult.fetching || bookDate === null}
            type="button"
            label="Book"
          >
            Book
          </Button>
        </div>
      </div>
    </>
  );
};

export default SetBooking;
